__webpack_require__.p = "/devendra/";